import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { GlobalMessageType, RoutingService } from '@spartacus/core'
import { Subscription } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { CustomRoutes } from '../../../../models/enum/custom-routes.enum'
import { SharedValue } from '../../../../models/enum/shared.enum'
import { IAgreement } from '../../../../models/interface/agreement.interface'
import { ICsv } from '../../../../models/interface/csv.interface'
import { RebateClaim } from '../../../../models/rebate-claim.model'
import { RebateClaimService } from '../../../../services/rebate-claims/rebate-claim.service'
import { CsvService } from '../../../../services/shared/csv/csv.service'
import { CustomGlobalMessageService } from '../../../../services/shared/custom-global-message/custom-global-message.service'
import { SharedService } from '../../../../services/shared/shared.service'
import { CustomTableColumnType } from '../../../shared/custom-components/custom-table/modals/enum/custom-table.enum'
import {
  ICustomTableColumn,
  ICustomTableHeader
} from '../../../shared/custom-components/custom-table/modals/interface/custom-table.interface'

@Component({
    selector: 'app-rebate-claims-details',
    templateUrl: './rebate-claims-details.component.html',
    styleUrls: ['./rebate-claims-details.component.scss'],
    standalone: false
})
export class RebateClaimsDetailsComponent implements OnInit, OnDestroy {
  public rebateClaim: RebateClaim
  public rebateClaimCode: string
  public agreement: IAgreement
  public entries: RebateClaim
  public showLoaderOnPagination: boolean
  public showInitialLoader: boolean = true
  public subscription = new Subscription()

  public headers: ICustomTableHeader[] = [
    { title: 'shared.date' },
    { title: 'rebateClaims.distributorNumber' },
    { title: 'rebateClaims.endCustomerNumber' },
    { title: 'shared.sku' },
    { title: 'shared.volume' },
    { title: 'shared.price' },
    { title: 'shared.uom' },
    { title: 'rebateClaims.distributorEndCustomerNumber' },
    { title: 'shared.total' }
  ]

  public columns: ICustomTableColumn[] = [
    { key: 'date', type: CustomTableColumnType.DATE },
    { key: 'distributorNo' },
    { key: 'endCustomerNo' },
    { key: 'sku' },
    { key: 'originalQuantity' },
    { key: 'formattedOriginalPrice' },
    { key: 'originalUom' },
    { key: 'distributorEndUserNumber' },
    { key: 'formattedTotal' }
  ]

  constructor(
    private globalMessageService: CustomGlobalMessageService,
    public sharedService: SharedService,
    private csvService: CsvService,
    private changeDetectorRef: ChangeDetectorRef,
    private rebateClaimService: RebateClaimService,
    public routingService: RoutingService
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  ngOnInit(): void {
    this.subscription.add(
      this.sharedService
        .getUrlParam('code')
        .pipe(
          switchMap((code: string) => {
            return this.rebateClaimService.getRebateClaimByCode(code)
          })
        )
        .subscribe({
          next: (data) => {
            if (data) {
              this.rebateClaim = data
              this.entries = data
              this.showInitialLoader = false
              this.changeDetectorRef.detectChanges()

              console.log('data', data)
            } else {
              this.globalMessageService.add(SharedValue.documentNotFound, GlobalMessageType.MSG_TYPE_ERROR)
              // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
              this.routingService.go({
                cxRoute: CustomRoutes.REBATE_CLAIMS
              })
            }
          },
          error: () => {
            this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
            // TODO:Spartacus - 'RoutingService.go' changed signature. Before 4.0, the object with query params could be passed in the 2nd argument. Now the 2nd argument is Angular NavigationExtras object (with 'queryParams' property).
            this.routingService.go({
              cxRoute: CustomRoutes.REBATE_CLAIMS
            })
          }
        })
    )
  }

  public downloadCSV(): void {
    const csv: ICsv = {
      title: `Rebate Claim Details ${this.entries?.rebateClaimCode}`,
      columns: [
        { title: 'shared.date', key: 'date', type: CustomTableColumnType.DATE },
        { title: 'rebateClaims.distributorNumber', key: 'distributorNo' },
        { title: 'rebateClaims.endCustomerNumber', key: 'endCustomerNo' },
        { title: 'shared.sku', key: 'sku' },
        { title: 'shared.volume', key: 'originalQuantity' },
        { title: 'shared.price', key: 'formattedOriginalPrice' },
        { title: 'shared.uom', key: 'originalUom' },
        { title: 'rebateClaims.distributorEndCustomerNumber', key: 'distributorEndUserNumber' },
        { title: 'shared.total', key: 'formattedTotal' }
      ],
      rows: this.entries.items
    }
    this.csvService.generateCSV(csv)
  }
}
